export default "__VITE_ASSET__354beb24__"